import { defineMessages } from 'react-intl';

const _default_1: {
	labelCancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelEsc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	labelCancel: {
		id: 'fabric.editor.ai.components.cancelEscButton.cancelLabel',
		defaultMessage: 'Cancel',
		description: 'CancelEsc\'s "Cancel" button label',
	},
	labelEsc: {
		id: 'fabric.editor.ai.components.cancelEscButton.escLabel',
		defaultMessage: 'Esc',
		description: 'CancelEsc\'s "Esc" button label',
	},
});
export default _default_1;
